import { graphql } from '~/graphql/generated/gql';

export const SUBMIT_USER_FEEDBACK = graphql(`
  mutation SubmitUserFeedback($input: SubmitUserFeedbackInput!) {
    core {
      userFeedback {
        submitUserFeedback(input: $input) {
          feedback {
            id
          }
        }
      }
    }
  }
`);

export const SUBMIT_PLATFORM_FEEDBACK = graphql(`
  mutation SubmitPlatformFeedback($input: SubmitPlatformFeedbackInput!) {
    core {
      userFeedback {
        submitPlatformFeedback(input: $input) {
          feedback {
            id
          }
        }
      }
    }
  }
`);
